var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1C2033",
    width: 52,
    height: 52,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8004 14.1007H36.5004L41.8004 5.20069C42.4004 4.10069 42.1004 2.80069 41.0004 2.10069C39.9004 1.50069 38.6004 1.80069 37.9004 2.90069L31.3004 14.1007H30.6004L24.0004 6.30069C23.2004 5.40069 21.8004 5.20069 20.8004 6.00069C19.8004 6.80069 19.7004 8.20069 20.5004 9.20069L24.6004 14.1007H10.2004C6.80039 14.1007 3.90039 16.9007 3.90039 20.4007V49.9007C3.90039 53.3007 6.70039 56.2007 10.2004 56.2007H11.3004V60.0007C11.3004 61.2007 12.3004 62.3007 13.6004 62.3007C14.9004 62.3007 15.9004 61.3007 15.9004 60.0007V56.1007H48.3004V60.0007C48.3004 61.2007 49.3004 62.3007 50.6004 62.3007C51.9004 62.3007 52.9004 61.3007 52.9004 60.0007V56.1007H54.0004C57.4004 56.1007 60.3004 53.3007 60.3004 49.8007V20.3007C60.1004 16.9007 57.3004 14.1007 53.8004 14.1007ZM55.6004 49.8007C55.6004 50.8007 54.8004 51.6007 53.8004 51.6007H10.2004C9.20039 51.6007 8.40039 50.8007 8.40039 49.8007V20.3007C8.40039 19.3007 9.20039 18.5007 10.2004 18.5007H53.9004C54.9004 18.5007 55.7004 19.3007 55.7004 20.3007V49.8007H55.6004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv1);
export default __webpack_public_path__ + "static/media/tv-1.cb61e7eb74f4870fbdd39503144b28a9.svg";
export { ForwardRef as ReactComponent };